import { createWebHistory, createRouter } from 'vue-router'

// solutions
import MainPage from './components/pages/MainPage.vue'
import TotalPage from './components/pages/solution/TotalPage.vue'
import BedbugPage from './components/pages/solution/BedbugPage.vue'
import FlyPage from './components/pages/solution/FlyPage.vue'
import VirusCarePage from './components/pages/solution/VirusCarePage.vue'
import AirSterilePage from './components/pages/solution/AirSterilePage.vue'
import DualcarePage from './components/pages/solution/DualcarePage.vue'
import AirPage from './components/pages/solution/AirPage.vue'
import WaterPage from './components/pages/solution/WaterPage.vue'
import ScentPage from './components/pages/solution/ScentPage.vue'

// location
import HomePage from './components/pages/location/HomePage.vue'
import RestaurantPage from './components/pages/location/RestaurantPage.vue'
import RetailPage from './components/pages/location/RetailPage.vue'
import EduPage from './components/pages/location/EduPage.vue'
import BuildingPage from './components/pages/location/BuildingPage.vue'
import ServicePage from './components/pages/location/ServicePage.vue'
import CulturePage from './components/pages/location/CulturePage.vue'
import MedicalPage from './components/pages/location/MedicalPage.vue'
import HotelPage from './components/pages/location/HotelPage.vue'
import MotelPage from './components/pages/location/MotelPage.vue'
import FoodfactoryPage from './components/pages/location/FoodfactoryPage.vue'
import FactoryPage from './components/pages/location/FactoryPage.vue'
import StoragePage from './components/pages/location/StoragePage.vue'
import ListPage from './components/pages/location/ListPage.vue'

import WhyMembers from './components/pages/WhyMembers.vue'
import ContactPage from './components/pages/ContactPage.vue'
import MailSendPage from './components/pages/MailSendPage.vue'

const routes = [
  {
    path: '/',
    name: '메인',
    component: MainPage
  },
  {
    path: '/solution/service/total',
    name: '통합 해충 방지 솔루션',
    component: TotalPage
  },
  {
    path: '/solution/service/fly',
    name: '비래해충 솔루션',
    component: FlyPage
  },
  {
    path: '/solution/service/bedbug',
    name: '빈대방제 솔루션',
    component: BedbugPage
  },
  {
    path: '/solution/service/virusCare',
    name: '바이러스 케어 솔루션',
    component: VirusCarePage
  },
  {
    path: '/solution/service/airSterile',
    name: '공기살균기',
    component: AirSterilePage
  },
  {
    path: '/solution/service/dualcare',
    name: '공기살균청정기',
    component: DualcarePage
  },
  {
    path: '/solution/service/air',
    name: '공기청정기',
    component: AirPage
  },
  {
    path: '/solution/service/water',
    name: '정수기',
    component: WaterPage
  },
  {
    path: '/solution/service/scent',
    name: '향기솔루션 에어퍼퓸',
    component: ScentPage
  },
  {
    path: '/homepage/info/whyMembers',
    name: 'Why 세스코멤버스',
    component: WhyMembers
  },
  {
    path: '/solution/place/home',
    name: '장소별 추천 가정집',
    component: HomePage
  },
  {
    path: '/solution/place/restaurant',
    name: '장소별 추천 외식업장',
    component: RestaurantPage
  },
  {
    path: '/solution/place/retail',
    name: '장소별 추천 유통시설',
    component: RetailPage
  },
  {
    path: '/solution/place/edu',
    name: '장소별 추천 교육시설',
    component: EduPage
  },
  {
    path: '/solution/place/building',
    name: '장소별 추천 빌딩시설',
    component: BuildingPage
  },
  {
    path: '/solution/place/service',
    name: '장소별 추천 서비스시설',
    component: ServicePage
  },
  {
    path: '/solution/place/culture',
    name: '장소별 추천 문화시설',
    component: CulturePage
  },
  {
    path: '/solution/place/medical',
    name: '장소별 추천 의료시설',
    component: MedicalPage
  },
  {
    path: '/solution/place/hotel',
    name: '장소별 추천 특급호텔/리조트',
    component: HotelPage
  },
  {
    path: '/solution/place/motel',
    name: '장소별 추천 모텔/일반호텔',
    component: MotelPage
  },
  {
    path: '/solution/place/foodfactory',
    name: '장소별 추천 식품제조',
    component: FoodfactoryPage
  },
  {
    path: '/solution/place/factory',
    name: '장소별 추천 제조공장',
    component: FactoryPage
  },
  {
    path: '/solution/place/storage',
    name: '장소별 추천 창고시설',
    component: StoragePage
  },
  {
    path: '/solution/place/list',
    name: '장소별 추천 리스트',
    component: ListPage
  },
  {
    path: '/contact',
    name: '',
    component: ContactPage
  },
  {
    path: '/contact/mail/send',
    name: '메일 전송',
    component: MailSendPage
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
